/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCross = createReactComponent("cross", "IconCross", [
  ["path", { d: "M10 21h4v-9h5v-4h-5v-5h-4v5h-5v4h5z", key: "svg-0" }]
]);

export { IconCross as default };
//# sourceMappingURL=IconCross.js.map
